/* eslint-disable max-len */

export default {
  lang: 'Spanish',
  homeScreen: {
    title: 'Título',
    stayConnected: 'Permanece conectado',
    comingSoon: 'Próximamente',
    messages: 'Mensajes',
  },
  notification: {
    newAndNow: '¡Novedades!',
    alert: 'Alerta',
    message: 'Mensaje',
    contest: 'Concurso',
    badge: 'Nueva insignia',
    'content-update': 'Actualización de contenido',
    events: 'Eventos',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Veamos si podemos encontrar un perfil existente para ti en nuestro sistema.',
      homeTitleSub:
        'Ingresa la dirección de correo electrónico que utilizas normalmente para iniciar sesión en los programas de capacitación.',
      noAccount:
        'No se encontró ninguna cuenta ({email}), intente con otro correo electrónico o cree una cuenta ahora.',
      continueButton: 'Continuar',
      success:
        '¡Actualizaste exitosamente tu cuenta! Serás redirigido en breve a la página de inicio.',
      successNewAccount:
        'Para finalizar tu inscripción, te enviaremos un email de confirmación para validar tu cuenta.',
      loginButton: 'Inicio de sesión ',
      matchFound:
        'Hemos encontrado una coincidencia, ingresa tu contraseña para continuar.',
      magicLink:
        'Inicia sesión a través de un enlace en tu correo electrónico:',
      magicLinkButton: 'Solicitar enlace mágico',
      magicLinkTitle:
        'Recibe un enlace directo en tu correo electrónico que te permitirá iniciar sesión al instante.',
      otherEmailButton: 'Entregar',
      title:
        'Por favor, tómate un momento para completar toda la información a continuación, ya que llenará tu perfil personal y datos de contacto',
      titleIndustry:
        'Por favor, tómate un momento para completar toda la información a continuación, ya que llenará tu perfil personal y datos de contacto.',
      register: 'Crea una cuenta',
      agent: 'Asesor de viaje',
      visitor: 'Visitante de la industria',
      step1: 'Paso 1: tipo de usuario',
      step2: 'Paso 2: crea una cuenta',
      step3: 'Paso 3: crea tu perfil',
      marketingOptIn:
        '¿Está seguro de que no está interesado en permanecer conectado con el equipo de comercio de viajes de este programa?',
      optIn: 'Sí, estoy interesado',
      optOut: 'No estoy interesado',
      step2Sub1: 'Cuéntanos acerca de tí',
      step2Sub2: 'Cuéntanos sobre tu negocio',
      privacyHead: 'PREFERENCIAS DE COMUNICACIONES',
      privacySub:
        'Marca las casillas a continuación para asegurarte de recibir comunicaciones importantes del equipo de comercio de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de apoyo en ventas y networking para el comercio de viajes de TravPRO Mobile.',
      privacy:
        'Protegemos tu privacidad y nunca vendemos, hacemos mal uso o traicionamos tu confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'IMPULSADO POR',
      toastMessage: {
        forgotSuccess:
          '¡Hemos enviado por correo electrónico un enlace para restablecer tu contraseña! Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting:
          'La dirección de correo electrónico que ingresaste no existe.',
        magicLinkMessage: 'Espera, estamos iniciando sesión ahora mismo.',
        magicLinkError:
          'No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkError1:
          'No pudimos encontrar un token válido, por favor inicia sesión o solicita un nuevo enlace mágico. Si el problema persiste, por favor contáctanos en: info@travpromobile.comNo pudimos encontrar un token válido. Inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, contáctenos en: info@travpromobile.com.',
        magicLinkError2:
          'No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkSuccess:
          'Revisa tu correo electrónico en {email}. Tiene un enlace mágico que te permitirá iniciar sesión.',
        magicLinkErrorWait:
          'Por favor, espera 5 minutos entre solicitudes de enlaces mágicos',
        emailNotFoundError:
          'La dirección de correo electrónico que ingresaste no se encuentra en nuestros registros. Por favor, verifica si hay errores ortográficos o crea una cuenta nueva.',
      },
      errors: {
        zipCodeNotFound: 'Código postal no encontrado, inténtalo de nuevo',
        zipCodeOnlyNumbers: 'El código postal solo puede contener números.',
        password: 'Porfavor ingresa una contraseña',
        passwordNotMatching: 'Las contraseñas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
        emailExists:
          'Esta dirección de correo electrónico ya existe o es inválida. Por favor, intenta con otra dirección de correo electrónico o inicia sesión en tu cuenta',
        fillInAllFields: 'Por favor, completa todos los campos obligatorios.',
        fillInEmail: 'Por favor ingresa tu correo electrónico.',
        emailNotExisting:
          'La dirección de correo electrónico que ingresaste no existe.',
      },
      fields: {
        forgotSubCopy: ' ¿Olvidaste tu contraseña y quieres cambiarla?',
        forgotSubCopy2:
          ' ¿Quieres omitir la contraseña por completo? Te enviaremos un correo electrónico con un enlace mágico que lo iniciará automáticamente en el programa.',
        city: 'Ciudad',
        companyName: 'Nombre de empresa',
        role: 'Tu función',
        description: '¿Cuál describe mejor el negocio de tu empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elige una contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar Contraseña',
        firstName: 'Nombre',
        lastName: 'Apellido',
        agency: 'Nombre de tu agencia',
        title: 'Tu función (selecciona una)',
        company: 'Nombre de la empresa',
        select: 'Selecciona una opción a continuación',
        state: 'Estado',
        province: 'Provincia/Región/Estado',
        zipCode: 'Código postal',
        postalCode: 'Código Postal',
        affiliate: '¿A qué grupo pertenece tu agencia PRINCIPAL?',
        hostAgency: '¿Tu Agencia de Viajes?',
        executive: 'Ejecutivo',
        management: 'Gestión',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        other: 'Otro',
        opt: 'Mantente conectado con el equipo de comercio de viajes de este programa y recibe actualizaciones.',
        optMarketing:
          'Mantente conectado con TravPRO respecto a programas y eventos similares.',
        retail: 'Minorista',
        home: 'Freelancer',
        independent: 'Contratista independiente',
        host: 'Mayorista',
        call: 'Centro de llamadas o agencia basada en la web',
        describes: '¿Qué describe mejor tu negocio y el de su agencia?',
      },
    },
    title:
      'Programa de capacitación para profesionales de viajes y habilitación de ventas',
    welcome: {
      headerTop: 'Bienvenido a',
      headerBottom: 'Tampa Bay',
    },
    sellingPoints: {
      0: 'Aprende, promociona y vende sobre la marcha',
      1: 'Capacitación multimedia en todos los dispositivos',
      2: 'Certificado de finalización',
      3: 'Presentaciones de ventas listas para usar',
      4: 'Materiales promocionales de alto impacto',
      5: 'Consejos y promociones de expertos',
      6: 'Directorio de productos en tiempo real',
      7: 'Noticias y actualizaciones oportunas',
    },
    emailPrompt:
      'Ingresa tu dirección de correo electrónico y contraseña para confirmar que eres un profesional de viajes.',
    tAndC: {
      agree: ' Al continuar estás de acuerdo con nuestra',
      privacyPolicy: 'Política de Privacidad',
      and: ' y',
      termsConditions: 'Términos y Condiciones',
    },
    fields: {
      what: '¿Qué tipo de viajes venden?',
      what1: '¿Cuál es el tipo de viaje número uno que vende?',
      what2: '¿Cuál es el segundo tipo de viaje que vende?',
      what3: '¿Cuál es el tercer tipo de viaje que vende?',
      agency: 'Agencia *',
      email: 'Correo electrónico',
      password: 'Contraseña',
      passwordConfirm: 'Confirma la contraseña *',
      firstName: 'Nombre*',
      lastName: 'Apellido*',
      agencyName: 'Nombre de la agencia *',
      city: 'Ciudad *',
      stateProvince: 'Provincia/Estado *',
      salutation: 'Saludo *',
      required: 'Requerido',
      invalidEmail: 'Dirección de correo electrónico no válida',
      opt: '¡Mantente en contacto! Sí, me gustaría suscribirme a las comunicaciones de Visit Tampa Bay que me mantendrán informado sobre noticias, eventos, incentivos, FAM y más.',
      complete: 'Paso 2: Completa tu perfil',
      tell: 'Cuéntanos acerca de tí',
      title: 'Tu Cargo *',
      host: 'Nombre de la agencia ',
      country: 'País / Región',
      select: 'Por favor, selecciona una opción a continuación',
      header2: '¿Qué segmento(s) vendes principalmente?',
      step2: 'Describe tu negocio',
      leisure: 'Ocio',
      corporate: 'Corporativo',
      group: 'Grupo',
      affiliate: '¿Cuál es su principal afiliación?',
      forgot:
        '¿Olvidaste tu contraseña? Haz clic en el botón a continuación y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    noAgent: {
      noAgentButton: 'No soy un asesor',
      title: 'Gracias por tu interés en Tampa Bay',
      messageWeb:
        ' El contenido de este sitio es exclusivamente para profesionales de viajes. Para obtener más información sobre Tampa Bay visita:',
      messageMobile:
        "Parte del contenido en esta app está diseñado exclusivamente para profesionales de viaje, sin embargo, siéntete libre de echar un vistazo a una muestra de lo que esta aplicación tiene para ofrecer presionando 'Continuar'.",
      continue: 'Continuar',
      visitWebsite: 'Visita el sitio web',
    },
    newUser: 'Nuevo Usuario',
    register: 'Registro',
    registered: 'Este correo electrónico ya está registrado',
    forgot: ' Restablecer la contraseña',
    header:
      'Por favor, tómate un momento para completar toda la información a continuación, ya que esto es lo que llenará tu perfil y datos de contacto.',
    step1:
      'Paso 1: Complete su dirección de correo electrónico y elija una contraseña.',
  },
  welcomeScreen: {
    title: 'Bienvenido a la Bahía de Tampa',
    helloUser: 'Hola {{nombre}}',
    hello: 'Hola,',
    fromAgency: 'de {{agencia}}',
    notUser: '¿Sin {{nombre}}?',
    introOnline:
      '¡Capacítate en línea de inmediato o descarga el contenido para tenerlo siempre disponible sin necesidad de conexión a internet!',
    introOffline:
      'Ya tienes la última versión precargada. ¡Empieza a entrenar o vender en cualquier momento y en cualquier lugar!',
    startTraining: 'Comienza a aprender',
    continueTraining: 'Continuar aprendiendo',
    graduated: '¡Felicidades!',
    downloader: {
      preload: 'Precarga',
      stop: 'detener',
      init: 'Iniciando…',
      lastUpdate: ' Última actualización:',
    },
  },
  trainingScreens: {
    start: 'Comenzar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Revisar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% completado',
    unlock:
      'Desbloquea este capítulo completando el capítulo de capacitación {number}.',
    unlockSubtitle:
      'Acceda a más capítulos al finalizar los módulos de entrenamiento.',
    unlockSpecialization: 'Desbloquea este capítulo completando La Fundación.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: 'Has llegado al final',
    retainEnd:
      'Utiliza la barra superior para desplazarte en este capítulo o selecciona el botón de atrás para volver al resumen.',
    watchListenRead: 'Mira, escucha y lee más',
    trouble:
      'Parece que estás teniendo dificultades, por favor, vuelve a leer el contenido de la(s) página(s) anterior(es) e inténtalo nuevamente.',
    confirm: 'Confirma tu respuesta',
    choose: 'Por favor elige una respuesta',
    skip: 'Volver >',
    viewAllTitle: 'Consejo de entrenamiento',
    viewAll:
      'Para avanzar a la siguiente página, por favor, haz clic en los íconos para ver el contenido adicional. Se han proporcionado videos, mapas y otra información útil para mejorar tu capacitación y asegurar que alcances el estatus de PRO.',
    fillBlanks: 'Rellena los espacios en blanco:',
    next: 'Próxima pregunta',
    retry: 'Intenta otra vez',
    fastTrackText: {
      success:
        '¡Felicitaciones! Has completado el curso Fast Track y desbloqueado el resto de la capacitación.',
      failed:
        'Lamentablemente, no has aprobado el curso Fast Track. ¡Puedes continuar con tu entrenamiento para obtener tu diploma!',
    },
    fastTrack: '¡Conviértete en una superestrella de viajes!',
    fastTrackExplanation:
      '¡Simplemente responde el cuestionario de las siguientes páginas para tener la oportunidad de ganar un FAM para Suiza!<br><br><span style="font-weight: negrita">Encontrarás todas las respuestas a las preguntas del cuestionario de las siguientes maneras: </span><br><br>1. El contenido que aprendiste en los módulos de Rail Europe y Suiza<br><br>2. Y en los siguientes sitios web:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https:/ /www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts. net</a><br><br><span style="font-weight: Bold">Asegúrate de revisar estos recursos en detalle antes de realizar el cuestionario. Solo aquellos con las puntuaciones más altas tendrán la oportunidad de ser invitados al FAM.</span>',
    fastTrackButton: 'Haz clic aquí para realizar el cuestionario',
    grading: 'Tu nota final es: {grade}%',
  },
  nav: {
    home: 'Inicio',
    train: 'Aprender',
    learn: 'Aprender',
    retain: 'Recursos',
    directory: 'Directorio',
    showRoom: 'Muestras',
    showcases: 'Muestras',
    offers: 'Ofertas',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Recompensas',
    media: 'Medios de comunicación',
    favorites: 'Favoritos',
    contact: 'Conoce al equipo',
    reportCard: 'Ver diploma',
    accountSettings: 'Configuraciones de la cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Aprender',
    retain: 'Recursos',
    subapps: 'Módulos de socios de Tampa Bay',
    maintrainings: 'La Fundación',
    subtrainings: 'Especializaciones',
  },
  pageDescriptions: {
    train: 'Educa, participa y conviértete en un experto.',
    showroom: '',
    retain:
      '¡Felicitaciones por completar tu capacitación! Ahora has desbloqueado tu recurso principal para conservar tu conocimiento de experto y potenciar tus esfuerzos de ventas. Utiliza esta área para responder expertamente a una pregunta sobre el producto o incluso como una presentación de ventas improvisada, en cualquier momento, desde cualquier lugar y dispositivo.',
    promote:
      'Comparta estos elementos para despertar el interés e iniciar una conversación con clientes y prospectos.',
    sell: 'Responde las preguntas de los clientes y cierra la venta como un profesional con amplios recursos y soporte de ventas específico.',
    favorites: 'Mira tu contenido favorito personalmente',
    search: 'Mira todo el contenido',
    subapps: '',
    maintrainings:
      'Completa estos módulos esenciales para obtener su certificado.',
    subtrainings:
      'Mejore sus conocimientos y obtenga una insignia por cada módulo de especialización que se indica a continuación.',
  },
  general: {
    next: 'Próximo',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagen no encontrada',
    noResultsFor: 'No se han encontrado resultados para: {{query}}',
    noFavorites: 'Aún no tienes ningún favorito.',
    noMessages: '¡Aún no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡404 Pagina no encontrada!',
    oops: 'Uh oh...',
    overview: 'Volver a la descripción general',
    complete: 'Continuar',
    courseComplete: '¡Capítulo completo!',
    chapterComplete: 'Capítulo completado!',
    message: '{count} mensaje',
    messagePlural: '{count} mensajes',
    comingSoon: 'Próximamente',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Recopilación',
    layout: 'Disposición',
    web: 'Sitio web',
    pdf: 'PDF',
    carousel: 'Recopilación',
  },
  questions: {
    dials: 'Gira los discos para que coincidan con la respuesta.',
    fitb: 'Rellenar los espacios en blanco',
    flip: 'Cambia el número para que coincida con la respuesta.',
    multipleChoice: 'Elige la(s) respuesta(s) correcta(s)',
    slider: 'Elige la respuesta correcta usando el control deslizante',
    map: 'Responde la pregunta tocando la ubicación correcta en el mapa',
    dropdown: 'Elegir...',
    true: 'Verdadero',
    false: 'FALSO',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Darse de baja',
    settings: 'Configuración de privacidad',
    message:
      '¡No nos has dicho nada sobre tus preferencias de privacidad de datos! Está bien, pero nos gustaría ofrecerte la mejor experiencia utilizando Sales Companion.',
    disabled: 'Parece que has desactivado el uso de cookies.',
    use: '{{appName}} requiere el uso de cookies para brindarte la mejor experiencia.',
    details: '¿Para qué se utilizan las cookies?',
    enable: 'Vea cómo habilitar tus cookies {{aquí}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Necesitas iniciar sesión para ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message:
      'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Comprendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
  },
  sharing: {
    copyURL: 'Copiar link',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header:
      'Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visita tu tienda de aplicaciones y busca {appName} o haz clic en uno de los botones a continuación',
    benefits: {
      1: 'Aprende, promociona y vende sobre la marcha',
      2: 'Capacitación multimedia en todos los dispositivos',
      3: 'Certificado de finalización',
      4: 'Presentaciones de ventas listas para usar',
      5: 'Materiales promocionales de alto impacto',
      6: 'Directorio de productos en tiempo real',
      7: 'Noticias y actualizaciones oportunas',
      header: 'Esto te dará:',
    },
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Cantidad de resultados:',
    filter: 'Filtrar',
    filters: 'Filtros:',
    resetFilters: 'Restablecer filtros',
    showResults: 'Mostrar resultados',
    noResults:
      'No se han encontrado resultados. Intente con una búsqueda diferente.',
    resetMap: 'Restablecer mapa para iniciar >',
    viewNow: 'Ver ahora >',
  },
  directory: {
    eat: 'Comer',
    play: 'Jugar',
    stay: 'Permanecer',
    artsentertainment: 'Arte y entretenimiento',
    conventionservices: 'Servicios de convenciones',
    divingsnorkeling: 'Buceo y snorkel',
    film: 'Película',
    hotels: 'Hoteles',
    lgbtgymsandspas: 'LGBT+: Gimnasios y Spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Dónde alojarse',
    multiculturaldining: 'Multicultural: Comedor',
    multiculturalnightlife: 'Multicultural: Vida nocturna',
    nightlife: 'La vida nocturna',
    petfriendly: 'Mascota amigable',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Balnearios',
    sports: 'Deportes',
    transportation: 'Transporte',
    venues: 'Lugares',
    waterways: 'Vías navegables',
    waystoplay: 'Formas de jugar',
    weddinglocations: 'Lugares de boda',
    weddingvendors: 'Vendedores de bodas',
  },
  rewards: {
    rewards: 'Recompensas',
    title: 'Mónaco RECOMPENSAS',
    subTitle:
      '¡Te damos la oportunidad de ganar recompensas por convertirte en un especialista de nuestro programa y reservar viajes a Tampa Bay!',
    body: '¡Reserva un viaje a Tampa Bay para tener la oportunidad de ganar! Ingresa tus reservas para determinar la elegibilidad para ganar una recompensa de incentivo introductorio de una tarjeta de regalo electrónica de $5 de EE. UU./CAN.',
    item1:
      'Después de tu primera reserva confirmada de 4 noches o más (para una reserva individual), para un mínimo de dos (2) pasajeros, en un hotel/resort calificado. (Los cruceros no califican).',
    item2:
      'Oferta válida después de completar los Módulos Esenciales del Programa Tampa Bay.',
    link1: ' ¿Has reservado Tampa Bay?',
    link2: 'Si es así, envía tu reserva aquí.',
    button: 'Envía tu reserva',
    bookingForm: {
      title: 'Mónaco RECOMPENSAS',
      subTitle: 'Introduce tu reserva:',
      required: '* Indica un campo obligatorio',
      email: 'Correo electrónico del agente',
      agentFirstName: 'Nombre del agente',
      agentLastName: 'Apellido del agente',
      company: 'Nombre de la empresa',
      iata: '#IATA/CLIA',
      stateProvince: 'Provincia/estado',
      postalCode: 'Código postal',
      country: 'País',
      bookingNumber: 'Número de reserva',
      numberOfGuests: 'Cantidad de adultos',
      bookingDate: 'Fecha de reserva',
      tourOperator: 'Operador turístico',
      firstName: 'Nombre ',
      lastName: 'Apellido',
      accommodation: 'Nombre del alojamiento',
      wholesaler:
        'Nombre del mayorista (si corresponde): si se trata de una reserva directa, ingrese NINGUNO',
      arrivalDate: 'Fecha de llegada',
      departureDate: 'Fecha de salida',
      reservationNumber: 'Número de reserva',
      rooms: 'Número de habitaciones',
      stay: 'Duración de la estadía (en noches)',
      airline: 'Aerolínea/Transportista (código de 2 dígitos)',
      gateway: 'Origen (código de aeropuerto de 3 letras)',
      destination: 'Destino/isla (código de aeropuerto de 3 letras)',
      cost: 'Costo (use solo decimales)',
      disclaimer: '* Campos requeridos',
      button: 'Envía tu reserva',
      sub: 'Tu información',
      sub2: 'Infomación sobre reservas',
    },
    TermsAndConditions: {
      title: 'Términos y condiciones',
      subTitle: 'Recompensas trimestrales para especialistas de Tampa Bay',
      body1:
        'Toda publicación debe ir acompañada de un documento de prueba de venta con saldo cero que corresponda con cada reserva individual que se haya publicado. Los ganadores serán seleccionados en función de la totalidad de los documentos de prueba de venta verificados correspondientes a cada reserva enumerada. Las publicaciones deben seguir todas las reglas de Tampa Bay Specialist Rewards para su elegibilidad. Los premios no son transferibles y deben canjearse dentro de los tres (3) meses posteriores a la notificación del premio. Se perderá el derecho a cualquier premio no utilizado, no reclamado o rechazado. Los premios se emitirán trimestralmente y la elegibilidad se verificará en función del viaje completado.',
      body2:
        'Para ser elegible, debe residir en los EE. UU. o Canadá y tener la mayoría de edad o más en el estado, provincia o territorio de residencia. Los empleados del operador turístico NO son elegibles para los sorteos y NO serán considerados para premios adicionales. Los residentes de la provincia de Quebec NO son elegibles para los sorteos y NO serán considerados para premios adicionales.',
      body3:
        'La emisión de recompensas puede requerir prueba de acreditación como asesor de viajes minorista o a domicilio. Las recompensas disponibles están sujetas a cambios durante el transcurso del programa.',
      body4: 'Privacidad y uso de información personal',
      body5:
        'Los agentes participantes (i) otorgan al Recompensador el derecho a utilizar su nombre, ciudad, estado, provincia, código postal, confirmación de mayoría de edad, número de teléfono y dirección de correo electrónico para incluir, entre otros, contactar y anunciar a los Premiados. y entrega de premios; (ii) otorga al galardonado el derecho a utilizar su información personal con fines publicitarios y promocionales relacionados con los premios, en todos y cada uno de los medios ahora conocidos o ideados en el futuro, sin compensación adicional a menos que lo prohíba la ley; y (iii) reconoce que los premiados pueden revelar su información personal a agentes externos y proveedores de servicios en relación con cualquiera de las actividades enumeradas en (i) y (ii) anteriores.',
      button: 'Volver al aterrizaje',
    },
    thankYouPage: {
      thanks: 'Gracias',
      congrats: 'Felicidades,',
      body: 'su reserva ha sido recibida y enviada al supervisor de campaña para su verificación.',
      link: 'Tenga en cuenta que para ser un ganador, debe haber completado los Módulos Esenciales del Programa de Especialistas de Tampa Bay',
    },
  },
  custom: {
    splitUsers: 'Soy un ...',
    brandAmbassador: 'Embajador de la marca',
    travelPro: 'Profesional de viajes',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
